<template>
  <div id="app">
    <HomeHeader :isgzh="true"></HomeHeader>
    <div class="body_bg gzhbody_bg">
      <div class="container whitebg pd15">
        <el-row :gutter="25">
          <el-col
            :xs="24"
            :sm="24"
            :md="19"
            :lg="19"
            :xl="19"
            class="rightfloat"
          >
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="title_all" style="margin-bottom: 0">
                  <div class="title_left">
                    {{ this.id == -1 ? '最新一期' : YearIssue_No }}
                  </div>

                  <div class="clearfix"></div>
                </div>
                <div class="side_container">
                  <div class="dqml">
                    <IssueArticleListControl
                      :newListTitle="newListTitle"
                      :CloumnList="CloumnList"
                      :List="newList"
                      :Periods="Periods"
                      :isOA="false"
                      :type="0"
                      :id="id == -1 ? 1 : 0 || id == 1 ? 2 : 0"
                      v-loading="loading"
                      :isdataa="true"
                      :isgzh="true"
                    ></IssueArticleListControl>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import IssueArticleListControl from '../components/IssueArticleListControl/IssueArticleListControl'
import HomeHeader from '@/components/MasterTop'
export default {
  data() {
    return {
      keywords: '',
      activeName: 'first',
      data: {},
      newList: [],
      List: [],
      Lista: [],
      newListTitle: '',
      CoverGUID: false,
      BackCoverGUID: false,
      TableConGUID: false,
      Rss: false,
      loading: true,
      cotype: '',
      Periods: {},
      FileGUID: '',
      count: 0,
      titles: '',
      isyuchuban: false,
      YearIssue_No: '',
      id: 0,
      type: '',
      CloumnList: [],
      paramas: {
        PageSize: 100,
        PageIndex: 1,
        IssueId: 0,
      },
    }
  },
  components: {
    IssueArticleListControl,
    HomeHeader,
  },
  created() {
    if (this.id == -1) {
      document.title = '最新一期'
    } else if (this.id == 1) {
      document.title = '当期目录'
    }
    this.id = this.$route.query.IssueId
    this.type = this.$route.query.type
    this.GetIssue()
    this.getArticList()
  },
  mounted() {
    // this.$nextTick(function () {
    //   window.addEventListener('scroll', this.load)
    // })
  },
  watch: {
    $route(to, from) {
      if (to.query.IssueId !== from.query.IssueId) {
        this.id = to.query.IssueId
        this.GetIssue()
        this.CloumnList = []
        this.getArticList()
      }
    },
  },
  methods: {
    GetIssue() {
      this.$store
        .dispatch('_getYear', { Id: this.id })
        .then((res) => {
          this.newListTitle = res.data.Data.YearIssue_NoTtitle
          this.YearIssue_No = res.data.Data.YearIssue_No
          this.Periods = res.data.Data
          this.titles = '当期目录'
        })
        .catch((err) => {
          console.log(err)
        })
    },

    getArticList(PageSize, PageIndex, IssueId) {
      this.paramas = {
        PageSize: PageSize ? PageSize : 100,
        PageIndex: PageIndex ? PageIndex : this.paramas.PageIndex,
        IssueId: this.id,
      }
      this.$store
        .dispatch('_getNewlist', this.paramas)
        .then((res) => {
          this.loading = false
          this.newList = res.data.Data
          this.List = res.data.Data
          this.count = res.data.ItemCount
          this.List.map((item) => {
            if (item.Column) {
              this.CloumnList.push(item)
            }
          })
        })
        .catch((err) => {
          console.log(err)
        })
    },
    _getListb(pageSize, PageIndex) {
      var time = new Date().getTime()
      this.paramsa = {
        PageSize: pageSize ? pageSize : 100,
        PageIndex: PageIndex ? PageIndex : this.paramsa.PageIndex,
        Type: this.type,
        Key: this.id,
        src: time,
      }
      this.$store
        .dispatch('_getListb', this.paramsa)
        .then((res) => {
          if (res.data.IsSuccess) {
            this.loading = false
            this.newList = res.data.Data
            this.count = res.data.ItemCount
            this.YearIssue_No = res.data.Title
            this.titles = res.data.Title
          }
        })
        .catch((err) => {
          console.log(err, 'err')
        })
    },

    load() {
      if (
        document.documentElement.scrollHeight -
          document.documentElement.scrollTop <
        2000
      ) {
        if (this.paramas.PageIndex < this.count / 10 + 1) {
          this.paramas.PageIndex++
          this.$store.dispatch('_getNewlist', this.paramas).then((res) => {
            this.newList = this.newList.concat(res.data.Data)
          })
        }
      }
    },
  },
}
</script>

<style scoped></style>
